const axios = require('axios')

export default class Investments {
    getInvestments(size = 10, page = 1, sort = null, filters = null) {
        return axios.get(`/investments?page=${page}&size=${size}&${sort}&${filters}`)
    }

    getInvestmentsPublic(size = 10, page = 1, sort = null, filters = null) {
        return axios.get(`/investments/public?page=${page}&size=${size}&sort=${sort}&${filters}`)
    }

    getInvestmentPublic(id) {
        return axios.get(`/investments/${id}`)
    }

    createInvest(id, data) {
        return axios.post(`/investments/${id}`, data)
    }

    requestDocument(data) {
        return axios.post('/request_document',  data)
    }

    getRequestDocument(investId) {
        return axios.get(`/request_document/${investId}`)
    }

    getDocumentsAttached(requestId) {
        return axios.get(`/attach_document/${requestId}`)
    }

    attachDocument(data) {
        return axios.post('/attach_document',  data)
    }

    updateAttachStatus(id, data) {
        return axios.patch(`/attach_status/${id}`,  data)
    }

    confirm(data) {
        return axios.post('/investments/confirm',  data)
    }

    getStages(page, size, sort, filters) {
        return axios.get(`/settings/stages?page=${page}&size=${size}&${sort}&${filters}`)
    }

    getById(id) {
        return axios.get(`/invest/detail/${id}`)
    }

    authorize(id) {
        return axios.post(`/invest/authorize/${id}`)
    }

    generateReferencePayment(data) {
        return axios.post(`/pay_reference`, data)
    }

    getReferencePayment(id) {
        return axios.get(`/pay_reference/${id}`)
    }

    notifyPayment(data) {
        return axios.post(`/notify_payment`, data)
    }

    confirmPayment(data) {
        return axios.post(`/confirm_payment`, data)
    }
}